import { apiClient } from '@/services/apiClient';

/**
 * Update an employee's public holiday country override.
 * Pass null for countryCode to clear the override and revert to org default.
 */
export async function updateEmployeePublicHolidayCountry(
  employeeId: number,
  countryCode: string | null
): Promise<{ success: boolean; message: string; publicHolidayCountry: string | null; absencesCreated: number }> {
  return apiClient.patch<{ success: boolean; message: string; publicHolidayCountry: string | null; absencesCreated: number }>(
    `/employees/${employeeId}/public-holiday-country`,
    { countryCode }
  );
}
